import { Component, Injector, OnInit } from '@angular/core';
import { ModulesEnum, ProjectValuationTabs } from 'src/app/navigation/enum';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { WorkplaceAreaHostBase } from '../../../components/common/workplace-area-host-base/workplace-area-host-base';
import { RaciNavigationService } from '../../../navigation/raci-navigation.service';

/**
 * Angular host component for the project valuation area
 */
@Component({
  selector: 'project-valuation-host',
  templateUrl: './project-valuation-host.component.html',
  styleUrls: ['./project-valuation-host.component.scss']
})
export class ProjectValuationHostComponent extends WorkplaceAreaHostBase implements OnInit {
  /**
   * Sets the infobar visibility
   * @param mode Show (true) or hide
   * @param areaChanged Area changed?
   * @param enableSettings Enable settings
   * @param params Parameters
   */
  public setInfoBarVisibility(mode: boolean, areaChanged: boolean, enableSettings: boolean = undefined, params: any = undefined) {
    this.infoBarVisibility = mode;

    this.eventBus.broadcastEvent('comparables-infobar-changed', {
      show: mode, areaChanged, enableSettings, params
    });
  }
  /**
   * Participants form visibility
   */
  public showParticipantsForm = false;

  /**
   * Show raci module
   */
  public showRaciModule = false;

  /**
   * Indicates whether to show participants assignment
   */
  public showParticipantsAssignment = false;

  /**
   * Constructor
   * @param navigationService NavigationService
   * @param raciNavigationService RaciNavigationService
   * @param injector Angular Injector
   */
  constructor(private navigationService: NavigationService,
    private raciNavigationService: RaciNavigationService,
    injector: Injector
  ) {
    super(injector);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.raciNavigationService._showParticipantsAssignment.subscribe(response => {
      this.showParticipantsAssignment = response;
    });
    this.raciNavigationService._showParticipantsForm.subscribe(response => {
      this.showParticipantsForm = response;
    });

    this.navigationService.setActiveModule(ModulesEnum.ProjectValuation);
    this.navigationService.setActiveProjectValuationTab(ProjectValuationTabs.Projects);

    this.onEvents.push(this.eventBus.subscribeEvent('searchBarVisibility', (visibility, tab) => {
      this.searchTabVisible = visibility;
      this.searchTab = tab;
      this.setPVSearchModeVisibility(visibility);
    }));

    this.raciNavigationService._showHideRaciModule.subscribe(data => {
      this.showRaciModule = data;
    });
  }

  /**
   * Gets theinfobar visibility
   * @returns
   */
  public getPVInfoBarVisibility(): boolean {
    return this.getInfoBarVisibility();
  }

  /**
   * Sets the infobar visibility
   * @param mode Show (true) or hide
   * @param areaChanged Area changed?
   * @param enableSettings Enable settings
   * @param params Parameters
   */
  public setPVInfoBarVisibility(mode: boolean, areaChanged: boolean, enableSettings: boolean, params: any) {
    this.setInfoBarVisibility(mode, areaChanged, enableSettings, params);
  }

  /**
   * Sets the search bar visibility
   * @param mode Show (true) or hide
   */
  public setPVSearchModeVisibility(mode: boolean): void {
    this.setSearchModeVisibility(mode);
  }

  /**
   * Resizes the infobar
   * @param width The width in px
   */
  public resizeInfobar(width: number) {
    this.resizePane('#project-valuation-infobar', width);
  }

  /**
   * Gets the default pane widths
   * @returns the default pane widths
   */
  public getPaneWidths(): Map<string, number> {
    return new Map<string, number>([
      ['#project-valuation-infobar', 250],
      ['#project-valuation-searchbar', 250]
    ]);
  }
}
